import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=2541b09b&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=2541b09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541b09b",
  null
  
)

export default component.exports